import { render } from "./ReservationDetail.vue?vue&type=template&id=1445d8ec&scoped=true"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"

import "./ReservationDetail.vue?vue&type=style&index=0&id=1445d8ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1445d8ec"]])

export default __exports__